import type { MessageType } from '@eaphone/types/resources';

export const types: Record<MessageType, string> = {
  yujingxiaoxi: '预警消息',
  xitongxiaoxi: '系统消息',
  chengyuanxiaoxi: '成员消息',
  yichangxiaoxi: '异常消息',
  fuwuxiaoxi: '服务消息',
};
